// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vADTO","col":"styles_col__1iw_Z"};